// root route
export const ROUTE_ROOT = '/';
export const BASE_MARKETING_URL = 'https://www.litterati.org/';

// login route
export const ROUTE_LOGIN = '/login';

// Forgot Password route
export const FORGOT_PASSWORD = '/reset-password';

// payments route
export const ROUTE_PAYMENTS = '/payments';

// partner signup
export const ROUTE_PARTNER_SIGNUP = '/partner-signup';

// Sign-up route
export const ROUTE_SIGNUP = '/sign-up';

// dashboard route
export const ROUTE_TAGGING = '/tagging';

// dashboard route
export const ROUTE_DASHBOARD = '/dashboard';

// challenges listing route
export const ROUTE_CHALLENGES = '/challenges';

// single challenge route e.g. `/challenge/10453`
export const ROUTE_CHALLENGE = '/challenges/:challengeId';

// single challenge route e.g. `/challenge/10453`
export const ROUTE_CHALLENGE_EDIT = '/challenges/:challengeId/edit';

// campaigns listing route
export const ROUTE_CAMPAIGNS = '/campaigns';

// single campaign route e.g. `/campaign/10453`
export const ROUTE_CAMPAIGN = '/campaigns/:challengeId';

// Invite Reoutes e.g. `/invite/someId`
export const ROUTE_INVITE = '/invite';

// download challenges report form route
export const ROUTE_DOWNLOAD_CHALLENGES = '/download-challenges';

// welcome screen show to contributors when they become a paid contributor
export const ROUTE_WELCOME = '/welcome';

// create challenge form route
export const ROUTE_NOT_FOUND = '/not-found';

// privacy policy URL
export const TERMS_AND_CONDITIONS_URL = `${BASE_MARKETING_URL}terms-of-service`;

// terms and privacy URL
export const PRIVACY_POLICY_URL = `${BASE_MARKETING_URL}privacy-policy`;

// segments route
export const ROUTE_SEGMENTS = '/segments';

// analysis route
export const ROUTE_ANALYSIS = '/analysis';
export const ROUTE_RESEARCH = '/research';
export const ROUTE_ANALYZE_RESEARCH = '/analyze';

export const ROUTE_RESOURCES = '/resources';

export const ROUTE_ADMIN = '/admin';

export const ROUTE_EXPORT = '/export';

export const ROUTE_MONITORING = '/monitoring';

export const ROUTE_404 = '/404';

export const ROUTE_CHALLENGE_CREATE = '/challenge/create';

//roleId that is allowed to access payments page
export const INDIVIDUAL_ROLE_ID = [101, 102];

export const AVAILABLE_PATH = [
    ROUTE_LOGIN,
    ROUTE_PAYMENTS,
    ROUTE_SIGNUP,
    ROUTE_TAGGING,
    ROUTE_DASHBOARD,
    ROUTE_CHALLENGES,
    ROUTE_CHALLENGE,
    ROUTE_CAMPAIGNS,
    ROUTE_CAMPAIGN,
    ROUTE_DOWNLOAD_CHALLENGES,
    ROUTE_WELCOME,
    ROUTE_INVITE,
    ROUTE_NOT_FOUND,
    TERMS_AND_CONDITIONS_URL,
    PRIVACY_POLICY_URL,
    ROUTE_SEGMENTS,
    ROUTE_ANALYSIS,
    ROUTE_RESEARCH,
    ROUTE_RESOURCES,
    ROUTE_404,
    ROUTE_ADMIN,
    ROUTE_EXPORT,
    ROUTE_PARTNER_SIGNUP,
    ROUTE_MONITORING,
    ROUTE_CHALLENGE_CREATE,
    ROUTE_CHALLENGE_EDIT,
    ROUTE_ANALYZE_RESEARCH,
];
